export const TOP_SELLING_PERIODS = [
    { key: "thisweek", label: "This Week" },
    { key: "thismonth", label: "This Month" },
    { key: "thisyear", label: "This Year" },
  ];